import { useCallback } from 'react';
import omit from 'lodash/fp/omit';
import { useHistory } from 'react-router-dom';
import { ResourceUserAvailabilityGroupType } from '~/types';
import { useResourceManagementContext } from '~/modules/resource-management/common';
import { primaryRoleTag } from '~/modules/common/components/SearchBox/Facets/RoleFacet/tag';
import { departmentTag } from '~/modules/common/components/SearchBox/Facets/DepartmentFacet/tag';
import { employeeTypeTag } from '~/modules/common/components/SearchBox/Facets/EmployeeTypeFacet/tag';
import { locationTag } from '~/modules/common/components/SearchBox/Facets/LocationFacet/tag';
import { divisionTag } from '~/modules/common/components/SearchBox/Facets/DivisionFacet/tag';
import { serviceCenterTag } from '~/modules/common/components/SearchBox/Facets/ServiceCenterFacet/tag';
import { costCenterTag } from '~/modules/common/components/SearchBox/Facets/CostCenterFacet/tag';

const GROUP_BY_TO_TAG_MAP = {
  [ResourceUserAvailabilityGroupType.Role]: primaryRoleTag,
  [ResourceUserAvailabilityGroupType.Department]: departmentTag,
  [ResourceUserAvailabilityGroupType.EmployeeType]: employeeTypeTag,
  [ResourceUserAvailabilityGroupType.Location]: locationTag,
  [ResourceUserAvailabilityGroupType.Division]: divisionTag,
  [ResourceUserAvailabilityGroupType.ServiceCenter]: serviceCenterTag,
  [ResourceUserAvailabilityGroupType.CostCenter]: costCenterTag
};

const getGroupCriterion = (groupBy, record) => {
  const tag = GROUP_BY_TO_TAG_MAP[groupBy];
  const uri =
    typeof record?.[groupBy] === 'string'
      ? record[groupBy]
      : record?.[groupBy]?.uri;

  if (!tag || !uri) return {};

  return {
    [tag]: [
      {
        displayText: record.label,
        id: uri,
        key: record.label,
        label: record.label,
        value: uri
      }
    ]
  };
};

const mergeSearchCriteria = ({ searchCriteria, groupBy, record }) => ({
  keywords: searchCriteria?.keywords || [],
  criterions: {
    ...searchCriteria?.criterions,
    ...getGroupCriterion(groupBy, record)
  }
});

const useNavigateToQuickAllocation = ({ groupBy } = {}) => {
  const { searchCriteria } = useResourceManagementContext();
  const history = useHistory();

  const navigateToQuickAllocation = useCallback(
    (record = null) => {
      const cleanedSearchCriteria = omit('__typename')(
        mergeSearchCriteria({ searchCriteria, groupBy, record })
      );

      history.push({
        pathname: '/quick-allocation',
        state: { searchCriteria: cleanedSearchCriteria }
      });
    },
    [searchCriteria, history, groupBy]
  );

  return navigateToQuickAllocation;
};

export default useNavigateToQuickAllocation;
